(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1820);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AboutComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8198);



function AboutComp() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-secondary py-14",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container mx-auto items-center gap-40 flex justify-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative sm:w-[455px] sm:h-[600px] flex justify-center w-[300px] h-[450px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/images/about-img.png",
                            alt: "",
                            layout: "fill"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-white",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            addClass: "text-[2.5rem] font-dancing",
                            baslik: "We Are Feane"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-4",
                            children: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don`t look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn`t anything embarrassing hidden in the middle of text. All"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "bg-primary py-[10px] px-[45px] rounded-[45px] mt-9",
                            children: "Read More"
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 2339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MenuWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8198);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9352);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);



// import MenuWrapperItem from "./MenuWrapperItem";



function MenuWrapper() {
    var liste = function liste(param) {
        var id = param.id, btnname = param.btnname;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            className: "py-2 px-6 rounded-3xl ".concat(isSeciliBtn === true ? "bg-secondary text-white" : "text-black"),
            onClick: function() {
                return setSeciliBtn(true);
            },
            children: btnname
        }, id);
    };
    var mwiliste = // menuwrapper itemlerı için mwiliste funtionu oluşturuyoruz. Bu funtction döngü ile çekilecek
    function mwiliste(param) {
        var id = param.id, gorsel = param.gorsel, baslik = param.baslik, fiyat = param.fiyat, yazi = param.yazi;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-secondary rounded-3xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full bg-[#f1f2f3] h-[180px] grid place-content-center rounded-bl-[46px] rounded-tl-2xl rounded-tr-2xl",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: "/product",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative w-36 h-36 z-50 hover:scale-110 transition-all",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                src: gorsel,
                                alt: "",
                                layout: "fill"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-white p-[25px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: "font-semibold text-3xl font-dancing grid place-content-center",
                            children: baslik
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-[15px] mt-3",
                            children: yazi
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between p-[10px] items-center mt-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: fiyat
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "bg-primary w-10 h-10 rounded-full grid place-content-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_5__/* .RiShoppingCart2Fill */ .tac, {})
                                })
                            ]
                        })
                    ]
                })
            ]
        }, id);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSeciliBtn = ref[0], setSeciliBtn = ref[1];
    var data = [
        {
            id: 1,
            btnname: "All"
        },
        {
            id: 2,
            btnname: "Burger"
        },
        {
            id: 3,
            btnname: "Pizza"
        },
        {
            id: 4,
            btnname: "Pasta"
        },
        {
            id: 5,
            btnname: "Fries"
        }, 
    ];
    // menuwrapper itemlerı için dizi oluşturuyoruz
    var mwidata = [
        {
            id: 1,
            gorsel: "/images/sebzelipizza.png",
            baslik: "Delicious Pizza",
            fiyat: "$20",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 2,
            gorsel: "/images/hamburger4.png",
            baslik: "Delicious Burger",
            fiyat: "$15",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 3,
            gorsel: "/images/sebzelipizza.png",
            baslik: "Delicious Pizza",
            fiyat: "$17",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 4,
            gorsel: "/images/kasarlimakarna.png",
            baslik: "Delicious Pasta",
            fiyat: "$18",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 5,
            gorsel: "/images/kizartma.png",
            baslik: "French Fries",
            fiyat: "$10",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 6,
            gorsel: "/images/yesilpizza.png",
            baslik: "Delicious Pizza",
            fiyat: "$15",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 7,
            gorsel: "/images/hamburger2.png",
            baslik: "Tasty Burger",
            fiyat: "$12",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 8,
            gorsel: "/images/hamburger3.png",
            baslik: "Tasty Burger",
            fiyat: "$14",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 9,
            gorsel: "/images/kasarlimakarna.png",
            baslik: "Delicious Pasta",
            fiyat: "$10",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "container mx-auto flex flex-col items-center mb-16 my-16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                baslik: "Our Menu",
                addClass: "font-dancing text-5xl"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center my-8 gap-5",
                children: data.map(function(id, btnname) {
                    return liste(id = id, btnname = btnname);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-8 grid md:grid-cols-3 sm:grid-cols-3 grid-cols-1 gap-4 ",
                children: mwidata.map(function(id, gorsel, baslik, fiyat, yazi) {
                    return mwiliste(id = id, gorsel = gorsel, baslik = baslik, fiyat = fiyat, yazi = yazi);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "bg-primary text-white rounded-[45px] mt-[45px] flex justify-center px-[55px] py-[10px]",
                    children: "View more"
                })
            })
        ]
    });
};


/***/ }),

/***/ 7278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Reservation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(2175);
// EXTERNAL MODULE: ./components/form/input.js
var form_input = __webpack_require__(4477);
// EXTERNAL MODULE: ./components/items/Button_primary.js
var Button_primary = __webpack_require__(6517);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(4231);
;// CONCATENATED MODULE: ./components/schema/reservationSchema.js

var reservationSchema = es/* object */.Ry({
    fullName: es/* string */.Z_().required("Full name is required").min(3, "Full name must be at least 3 characters"),
    phoneNumber: es/* string */.Z_().required("Phone number is required").min(10, "Phone number must be at least 10 characters"),
    yourMail: es/* string */.Z_().required("Email is required").email("Invalid email address"),
    manyPersons: es/* string */.Z_().required("persons is required"),
    resevationDate: es/* string */.Z_().required("Date is required")
});

// EXTERNAL MODULE: ./components/Title.js
var Title = __webpack_require__(8198);
;// CONCATENATED MODULE: ./components/Reservation.js










function Reservation() {
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, actions) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new Promise(function(resolve) {
                            return setTimeout(resolve, 4000);
                        });
                    case 2:
                        actions.resetForm();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(values, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            fullName: "",
            phoneNumber: "",
            yourMail: "",
            manyPersons: "",
            resevationDate: ""
        },
        onSubmit: onSubmit,
        validationSchema: reservationSchema
    }), values = ref.values, errors = ref.errors, touched = ref.touched, handleSubmit = ref.handleSubmit, handleChange = ref.handleChange, handleBlur = ref.handleBlur;
    var inputs = [
        {
            id: 1,
            type: "text",
            name: "fullName",
            label: "Your Name",
            value: values.fullName,
            errorMessage: errors.fullName,
            touched: touched.fullName
        },
        {
            id: 2,
            type: "tel",
            name: "phoneNumber",
            label: "Phone Number",
            value: values.phoneNumber,
            errorMessage: errors.phoneNumber,
            touched: touched.phoneNumber
        },
        {
            id: 3,
            type: "text",
            name: "yourMail",
            label: "Your Mail",
            value: values.yourMail,
            errorMessage: errors.yourMail,
            touched: touched.yourMail
        },
        {
            id: 4,
            type: "number",
            name: "manyPersons",
            label: "Haw Many Persons",
            value: values.manyPersons,
            errorMessage: errors.manyPersons,
            touched: touched.manyPersons
        },
        {
            id: 5,
            type: "datetime-local",
            name: "resevationDate",
            label: "Date",
            value: values.resevationDate,
            errorMessage: errors.resevationDate,
            touched: touched.resevationDate
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mx-auto py-12 place-content-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                    baslik: "Book A Table",
                    addClass: "text-[40px] font-dancing mb-10"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center gap-x-16 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "lg:flex-1 w-full",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col gap-y-3",
                                children: inputs.map(function(input) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(form_input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                                        onChange: handleChange,
                                        onBlur: handleBlur
                                    }), input.id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_primary/* default */.Z, {
                                    type: "submit",
                                    label: "Book Now"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:flex-1 w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1492.6086664479212!2d38.74759224818012!3d40.12926187218509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x407b2745eb082465%3A0xfc61603ecd992c4f!2sMarshall%20-%20Kale%20Nalburiye!5e0!3m2!1str!2str!4v1667486289434!5m2!1str!2str",
                            width: "600",
                            height: "450",
                            allowFullScreen: "",
                            loading: "lazy",
                            referrerPolicy: "no-referrer-when-downgrade"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 4477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);



function Input(props) {
    var type = props.type, label = props.label, errorMessage = props.errorMessage, touched = props.touched, inputProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, [
        "type",
        "label",
        "errorMessage",
        "touched"
    ]);
    // {type = props,name,label,placeholder,value}
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "relative block w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                        type: type,
                        className: "h-14 w-full border outline-none px-4 peer \n            ".concat(type !== "datetime-local" && "pt-2", "\n            ").concat(errorMessage ? "border-red-500" : "border-primary", "\n            "),
                        required: true
                    }, inputProps)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "absolute top-0 left-4 text-sm flex h-full items-center peer-focus:h-7 peer-focus:text-xs peer-valid:h-7 peer-valid:text-xs transition-all",
                        children: label
                    })
                ]
            }),
            touched && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-xs text-red-600",
                children: errorMessage
            })
        ]
    });
};


/***/ }),

/***/ 1820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/AboutComp.js
var AboutComp = __webpack_require__(1410);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/items/Button_primary.js
var Button_primary = __webpack_require__(6517);
// EXTERNAL MODULE: ./components/Title.js
var Title = __webpack_require__(8198);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
;// CONCATENATED MODULE: ./components/Campaigns.js








var data = [
    {
        id: 1,
        im: "/images/hamburger1.jpg",
        baslik: "Tasty Thurdays",
        indirim: "%20",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaHamburger */.v7m, {})
    },
    {
        id: 2,
        im: "/images/pizza.jpg",
        baslik: "Tasty Delicious",
        indirim: "%15",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaPizzaSlice */.Egf, {})
    },
    {
        id: 3,
        im: "/images/hamburger1.jpg",
        baslik: "Tasty Hamb1",
        indirim: "%10",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaHamburger */.v7m, {})
    },
    {
        id: 4,
        im: "/images/hamburger2.png",
        baslik: "Tasty Hamb2",
        indirim: "%30",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaHamburger */.v7m, {})
    },
    {
        id: 5,
        im: "/images/hamburger3.png",
        baslik: "Tasty Hamb3",
        indirim: "%35",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaHamburger */.v7m, {})
    },
    {
        id: 6,
        im: "/images/hamburger4.png",
        baslik: "Tasty Hamb4",
        indirim: "%40",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaHamburger */.v7m, {})
    }, 
];
function liste(param) {
    var id = param.id, im = param.im, baslik = param.baslik, indirim = param.indirim, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-secondary flex-1 rounded-md py-5 px-[15px] !flex items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-44 h-44 after:contents-[''] border-[5px] border-primary rounded-full overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "hover:scale-150 transition-all",
                        src: im,
                        alt: "",
                        layout: "fill",
                        objectFit: "cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                            baslik: baslik,
                            addClass: "text-2xl font-dancing hover:scale-150 transition-all"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "font-dancing my-2 hover:scale-150 transition-all",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[2.5rem]",
                                    children: indirim
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: " off"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_primary/* default */.Z, {
                            label: "Order Now"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-white text-7xl hover:scale-150 transition-all",
                    children: icon
                })
            ]
        })
    }, id);
}
function Campaigns() {
    var settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container relative justify-between mx-auto py-20 flex-wrap",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
            children: data.map(function(id, im, baslik, indirim, icon) {
                return liste(id = id, im = im, baslik = baslik, indirim = indirim, icon = icon);
            })
        }))
    });
};

;// CONCATENATED MODULE: ./components/Carousel.js







function Carousel() {
    var liste = function liste(param) {
        var id = param.id, baslik = param.baslik, prg = param.prg;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-48 z-50 text-white flex flex-col justify-between items-start gap-y-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        baslik: baslik,
                        addClass: "font-dancing text-6xl"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm sm:w-2/5 w-full",
                        children: prg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_primary/* default */.Z, {
                        label: "Order Now"
                    })
                ]
            })
        }, id);
    };
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true
    };
    var data = [
        {
            id: 1,
            baslik: "Fast Food Restaurant 1",
            prg: "1. Doloremque, itaque aperiam facilis rerum, commodi, temporibus sapiente ad mollitia laborum quam quisquam esse error unde. Tempora ex doloremque, labore, sunt repellat dolore, iste magni quos nihil ducimus libero ipsam."
        },
        {
            id: 2,
            baslik: "Fast Food Restaurant 2",
            prg: "2. Doloremque, itaque aperiam facilis rerum, commodi, temporibus sapiente ad mollitia laborum quam quisquam esse error unde. Tempora ex doloremque, labore, sunt repellat dolore, iste magni quos nihil ducimus libero ipsam."
        },
        {
            id: 3,
            baslik: "Fast Food Restaurant 3",
            prg: "3. Doloremque, itaque aperiam facilis rerum, commodi, temporibus sapiente ad mollitia laborum quam quisquam esse error unde. Tempora ex doloremque, labore, sunt repellat dolore, iste magni quos nihil ducimus libero ipsam."
        },
        {
            id: 4,
            baslik: "Fast Food Restaurant 4",
            prg: "4. Doloremque, itaque aperiam facilis rerum, commodi, temporibus sapiente ad mollitia laborum quam quisquam esse error unde. Tempora ex doloremque, labore, sunt repellat dolore, iste magni quos nihil ducimus libero ipsam."
        },
        {
            id: 5,
            baslik: "Fast Food Restaurant 5",
            prg: "5. Doloremque, itaque aperiam facilis rerum, commodi, temporibus sapiente ad mollitia laborum quam quisquam esse error unde. Tempora ex doloremque, labore, sunt repellat dolore, iste magni quos nihil ducimus libero ipsam."
        }
    ];
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-screen w-full container mx-auto -mt-[88px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 w-full h-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/images/hero-bg.jpg",
                    alt: "",
                    layout: "fill",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                children: data.map(function(id, baslik, prg) {
                    return liste(id = id, baslik = baslik, prg = prg);
                })
            }))
        ]
    });
};

;// CONCATENATED MODULE: ./components/customers/CustomerItem.js


function CustomerItem(param) {
    var imgSrc = param.imgSrc;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-4 mt-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-6 bg-secondary text-white rounded-[5px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base",
                        children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold text-lg",
                                children: "Moana Mitchell"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold text-base",
                                children: "magna aliqua"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-28 h-28 rounded-full border-4 border-primary mt-8 before:content-[''] before:absolute before:top-0 flex justify-center before:-translate-y-3 before:rotate-45 before:bg-primary before:w-[20px] before:h-[20px] ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: "rounded-full",
                    src: imgSrc,
                    alt: "",
                    layout: "fill",
                    objectFit: "contain"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/customers/Customers.js






function Customers() {
    var settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mx-auto my-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                baslik: "What says our customers",
                addClass: "font-dancing text-[40px] text-center"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem, {
                        imgSrc: "/images/client1.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem, {
                        imgSrc: "/images/client2.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem, {
                        imgSrc: "/images/client2.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem, {
                        imgSrc: "/images/client2.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem, {
                        imgSrc: "/images/client2.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem, {
                        imgSrc: "/images/client2.jpg"
                    })
                ]
            }))
        ]
    });
};

// EXTERNAL MODULE: ./components/Product/MenuWrapper.js
var MenuWrapper = __webpack_require__(2339);
// EXTERNAL MODULE: ./components/Reservation.js + 1 modules
var Reservation = __webpack_require__(7278);
;// CONCATENATED MODULE: ./pages/index.js







function Home() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Campaigns, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWrapper/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutComp/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservation/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Customers, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [937,376,66,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);